import React, { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { useAuthModalStore } from '../store/authModalStore';

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { openLogin, isOpen } = useAuthModalStore();

  useEffect(() => {
    if (!isAuthenticated && !isOpen) {
      openLogin();
    }
  }, [isAuthenticated, isOpen, openLogin]);

  if (!isAuthenticated) {
    return (
      <div style={{ padding: '120px 24px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', color: 'var(--secondary)', marginBottom: 8 }}>
          Sign in required
        </h2>
        <p style={{ color: 'var(--gray-500)' }}>
          Please sign in to access this page.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
